// dashboard
import { ADMIN_ADMIN_LIST_ROUTE, 
  ANNOUNCEMENT_LIST_ROUTE,
  ANNOUNCEMENT_ADD_ROUTE,
  ANNOUNCEMENT_UPDATE_ROUTE, 
  BLOG_AUTHOR_LIST_ROUTE,
  PODCAST_LIST_ROUTE,
  BLOG_UPDATE_ROUTE,
  BLOG_ADD_ROUTE, 
  BLOG_LIST_ROUTE,
  PODCAST_UPDATE_ROUTE, 
  FORGET_PASSWORD_LIST_ROUTE, 
  ICON_LIST_ROUTE, 
  LOGIN_LIST_ROUTE, 
  LOGOUT_LIST_ROUTE, 
  MEDIA_LIST_ROUTE, 
  MODULE_LIST_ROUTE, 
  PAGE_LIST_ROUTE, 
  PAGE_VIEW_LIST_ROUTE, 
  PEOPLE_LIST_ROUTE,
  CONTACT_US_LIST_ROUTE, 
  CUSTOMER_LIST_ROUTE,
  PERMISSION_LIST_ROUTE, 
  PRESS_RELEASE_LIST_ROUTE,
  PRESS_RELEASE_ADD_ROUTE, 
  PRESS_RELEASE_UPDATE_ROUTE,  
  RESET_PASSWORD_LIST_ROUTE,
  PODCAST_ADD_ROUTE, 
  ROLE_LIST_ROUTE, 
  ROLES_EDIT_LIST_ROUTE,
  NEWS_LIST_ROUTE,
  NEWS_ADD_ROUTE,
  NEWS_UPDATE_ROUTE, 
  routeConfig, 
  USER_PROFILE_LIST_ROUTE, 
  CONTENT_LIST_ROUTE,
  CONTENT_ADD_ROUTE,
  CONTENT_UPDATE_ROUTE,
  CATEGORY_LIST_ROUTE,
  CATEGORY_ADD_ROUTE,
  CATEGORY_UPDATE_ROUTE,
  SUB_CATEGORY_LIST_ROUTE,
  SUB_CATEGORY_ADD_ROUTE,
  SUB_CATEGORY_UPDATE_ROUTE,
  INDEX_LIST_ROUTE,
  INDEX_ADD_ROUTE,
  INDEX_UPDATE_ROUTE,
  EDITABLE_LIST_ROUTE,
  EDITABLE_ADD_ROUTE,
  EDITABLE_UPDATE_ROUTE,
  HEADER_LIST_ROUTE,
  JOB_LIST_ROUTE,
  JOB_ADD_ROUTE,
  JOB_UPDATE_ROUTE,
  DASHBOARD_LIST_ROUTE,
  INDEX_UPLOAD_LIST_ROUTE,
  JOB_APPLICATION_LIST_ROUTE,

  ADDITIONAL_HTML_LIST_ROUTE,
  NOTICE_LIST_ROUTE,

  HR_PAGE_LIST_ROUTE,
  COMPLIANCE_PAGE_LIST_ROUTE,
  OPERATIONS_PAGE_LIST_ROUTE,
  MARKETING_PAGE_LIST_ROUTE,
  BLOG_CATEGORY_LIST_ROUTE,
  AUDIT_LOG_LIST_ROUTE,
  WORKER_JOBS_LIST_ROUTE
} from "../constants/routeEnum";

import UserProfile from "pages/Authentication/UserProfile";
import Login from "pages/Authentication/Login";
// import ForgetPassword from "pages/Authentication/forgetPassword";

import Logout from "pages/Authentication/LogOut";
import Admins from "pages/Admin/Admin";

import BlogAuthor from "pages/blogAuthor";
import Media from "pages/media/mediaList";
import Job from "pages/Job/job";
import ResetPassword from "pages/Authentication/ResetPassword";
import ForgetPassword from "pages/Authentication/forgetPassword";
import Page from "pages/Page";
import PageView from "pages/PageView/PageView";
import blog from "pages/Blog/blog";
import IconList from "pages/Icon/IconList";
import Announcement from "pages/Announcement/Announcement";
import AddAnnouncement from "pages/Announcement/AddAnnouncement";
import UpdateAnnouncement from "pages/Announcement/UpdateAnnouncement";
import PressRelease from "../pages/PressRelease/PressRelease"
import PeopleList from "pages/People/PeopleList";
import ModulePage from "pages/Admin/component/Modules";
import Permissions from "pages/Admin/component/Permissions";
import RolesList from "pages/Admin/component/RolesList";
import RoleUpdator from "pages/Admin/component/RoleUpdator";
import ContactUs from "../pages/ContactUs/ContactUs";

import Customer from "../pages/Customer/UserList"

import Podcast from "pages/Podcast/Podcast";
import AddPodcast from "pages/Podcast/AddPodcast";
import UpdatePodcast from "pages/Podcast/UpdatePodcast";
import UpdateBlog from "pages/Blog/UpdateBlog";
import AddBlog from "pages/Blog/AddBlog";
import News from "pages/News/News";
import AddNews from "pages/News/AddNews";
import UpdateNews from "pages/News/UpdateNews";
import Content from "pages/Content/Content";
import AddContent from "pages/Content/AddContent";
import UpdateContent from "pages/Content/UpdateContent";
import Addpressrelease from "pages/PressRelease/AddPressRelease";
import UpdatePressrelease from "pages/PressRelease/UpdatePressRelease";
import Editableviews from "pages/EditableContent/EditableContent";
import UpdateHeader from "pages/DynamicHeader/UpdateHeader";
// import HomePage from "pages/HomePage/HomePage";
// import ResetPassword from "pages/Authentication/ResetPassword";
import Index from "pages/Index/Index";
import AddIndex from "pages/Index/AddIndex";
import UpdateIndex from "pages/Index/UpdateIndex";
import Updatejob from "pages/Job/UpdateJob";
import Addjob from "pages/Job/AddJob";
import DashBoard from "pages/DashBoard/DashBoard";
import IndexUpload from "pages/IndexUpload/IndexUpload";
import JobApplicationList from "pages/JobApplication/JobApplication";

import AdditionalHtml from "pages/AdditionalHtml/AdditionalHtml";
import NoticeList from "pages/Notices/Notices";

import CompliancePage from "pages/CompliancePage";
import OperationsPage from "pages/OperationsPage";
import MarketingPage from "pages/MarketingPage";
import HRPage from "pages/HRPage";
import Category from "pages/Category";
import Auditlog from "pages/auditlog/Auditlog";
import AddCategory from "pages/Category/AddCategory";
import UpdateCategory from "pages/Category/UpdateCategory";
import SubCategory from "pages/Subcategory/SubCategory";
import AddSubCategory from "pages/Subcategory/AddSubCategory";
import UpdateSubCategory from "pages/Subcategory/UpdateSubCategory";
import ContentCategory from "pages/Category/Category";
import WorkerJobs from "pages/WorkerJobs";


interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
  permissions:string[]
}

const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  // { path: "/", component: Home },

  // profile

  //userlist
  { path: USER_PROFILE_LIST_ROUTE, component: UserProfile ,permissions:routeConfig.USER_PROFILE_LIST_ROUTE},
  { path: ADMIN_ADMIN_LIST_ROUTE, component: Admins, permissions: routeConfig.ADMIN_ADMIN_LIST_ROUTE},
  { path: ROLE_LIST_ROUTE, component: RolesList,permissions: routeConfig.ROLE_LIST_ROUTE },
  { path: MODULE_LIST_ROUTE, component: ModulePage ,permissions: routeConfig.MODULE_LIST_ROUTE},
  { path: PERMISSION_LIST_ROUTE, component: Permissions ,permissions: routeConfig.PERMISSION_LIST_ROUTE},
  { path: USER_PROFILE_LIST_ROUTE, component: UserProfile ,permissions: routeConfig.USER_PROFILE_LIST_ROUTE},
  { path: BLOG_LIST_ROUTE, component: blog, permissions: routeConfig.BLOG_LIST_ROUTE},
  { path: MEDIA_LIST_ROUTE, component: Media,permissions: routeConfig.MEDIA_LIST_ROUTE },
  { path: BLOG_AUTHOR_LIST_ROUTE, component: BlogAuthor,permissions: routeConfig.BLOG_AUTHOR_LIST_ROUTE },
  { path: PAGE_LIST_ROUTE, component: Page,permissions: routeConfig.PAGE_LIST_ROUTE },
  { path: HR_PAGE_LIST_ROUTE, component: HRPage,permissions: routeConfig.HR_PAGE_LIST_ROUTE },
  { path: COMPLIANCE_PAGE_LIST_ROUTE, component: CompliancePage,permissions: routeConfig.COMPLIANCE_PAGE_LIST_ROUTE },
  { path: OPERATIONS_PAGE_LIST_ROUTE, component: OperationsPage,permissions: routeConfig.OPERATIONS_PAGE_LIST_ROUTE },
  { path: MARKETING_PAGE_LIST_ROUTE, component: MarketingPage,permissions: routeConfig.MARKETING_PAGE_LIST_ROUTE },
  { path: WORKER_JOBS_LIST_ROUTE, component: WorkerJobs,permissions: routeConfig.WORKER_JOBS_LIST_ROUTE },
  
  { path: PAGE_VIEW_LIST_ROUTE, component: PageView,permissions: routeConfig.PAGE_VIEW_LIST_ROUTE },
  
  { path: ICON_LIST_ROUTE, component: IconList,permissions: routeConfig.ICON_LIST_ROUTE },
  { path: ANNOUNCEMENT_LIST_ROUTE, component: Announcement,permissions: routeConfig.ANNOUNCEMENT_LIST_ROUTE },
  { path: ANNOUNCEMENT_ADD_ROUTE, component: AddAnnouncement,permissions: routeConfig.ANNOUNCEMENT_ADD_ROUTE },
  { path: ANNOUNCEMENT_UPDATE_ROUTE, component: UpdateAnnouncement,permissions: routeConfig.ANNOUNCEMENT_UPDATE_ROUTE },
  { path: PRESS_RELEASE_LIST_ROUTE, component: PressRelease,permissions: routeConfig.PRESS_RELEASE_LIST_ROUTE },
  { path: PRESS_RELEASE_ADD_ROUTE, component: Addpressrelease,permissions: routeConfig.PRESS_RELEASE_ADD_ROUTE },
  { path: PRESS_RELEASE_UPDATE_ROUTE, component: UpdatePressrelease,permissions: routeConfig.PRESS_RELEASE_UPDATE_ROUTE },
  { path: PEOPLE_LIST_ROUTE, component: PeopleList ,permissions: routeConfig.PEOPLE_LIST_ROUTE},
  { path: ROLES_EDIT_LIST_ROUTE, component: RoleUpdator,permissions: routeConfig.ROLES_EDIT_LIST_ROUTE},
  { path: CONTACT_US_LIST_ROUTE, component: ContactUs,permissions: routeConfig.CONTACT_US_LIST_ROUTE},

  
  { path: CUSTOMER_LIST_ROUTE, component: Customer,permissions: routeConfig.CUSTOMER_LIST_ROUTE},



  { path: PODCAST_LIST_ROUTE, component: Podcast,permissions: routeConfig.PODCAST_LIST_ROUTE},
  { path: PODCAST_ADD_ROUTE, component: AddPodcast,permissions: routeConfig.PODCAST_ADD_ROUTE},
  { path: PODCAST_UPDATE_ROUTE, component: UpdatePodcast,permissions: routeConfig.PODCAST_UPDATE_ROUTE},
  { path: BLOG_UPDATE_ROUTE, component: UpdateBlog,permissions: routeConfig.BLOG_UPDATE_ROUTE},
  { path: BLOG_ADD_ROUTE, component: AddBlog,permissions: routeConfig.BLOG_ADD_ROUTE},
  { path: NEWS_LIST_ROUTE, component: News,permissions: routeConfig.NEWS_LIST_ROUTE},
  { path: NEWS_ADD_ROUTE, component: AddNews,permissions: routeConfig.NEWS_ADD_ROUTE},
  { path: NEWS_UPDATE_ROUTE, component: UpdateNews,permissions: routeConfig.NEWS_UPDATE_ROUTE},
  { path: CONTENT_LIST_ROUTE, component: Content,permissions: routeConfig.CONTENT_LIST_ROUTE},
  { path: CONTENT_ADD_ROUTE, component: AddContent,permissions: routeConfig.CONTENT_ADD_ROUTE},
  { path: CONTENT_UPDATE_ROUTE, component: UpdateContent,permissions: routeConfig.CONTENT_UPDATE_ROUTE},
  { path: CATEGORY_LIST_ROUTE, component: ContentCategory,permissions: routeConfig.CATEGORY_LIST_ROUTE},
  { path: CATEGORY_ADD_ROUTE, component: AddCategory,permissions: routeConfig.CATEGORY_ADD_ROUTE},
  { path: CATEGORY_UPDATE_ROUTE, component: UpdateCategory,permissions: routeConfig.CATEGORY_UPDATE_ROUTE},
  { path: SUB_CATEGORY_LIST_ROUTE, component: SubCategory,permissions: routeConfig.SUB_CATEGORY_LIST_ROUTE},
  { path: SUB_CATEGORY_ADD_ROUTE, component: AddSubCategory,permissions: routeConfig.SUB_CATEGORY_ADD_ROUTE},
  { path: SUB_CATEGORY_UPDATE_ROUTE, component: UpdateSubCategory,permissions: routeConfig.SUB_CATEGORY_UPDATE_ROUTE},
  { path: INDEX_LIST_ROUTE, component: Index,permissions: routeConfig.INDEX_LIST_ROUTE},
  { path: INDEX_ADD_ROUTE, component: AddIndex,permissions: routeConfig.INDEX_ADD_ROUTE},
  { path: INDEX_UPDATE_ROUTE, component: UpdateIndex,permissions: routeConfig.INDEX_UPDATE_ROUTE},
  { path: JOB_LIST_ROUTE, component: Job,permissions: routeConfig.JOB_LIST_ROUTE},
  { path: JOB_UPDATE_ROUTE, component: Updatejob,permissions: routeConfig.JOB_UPDATE_ROUTE},
  { path: JOB_ADD_ROUTE, component: Addjob,permissions: routeConfig.JOB_ADD_ROUTE},
  { path: EDITABLE_LIST_ROUTE, component: Editableviews,permissions: routeConfig.EDITABLE_LIST_ROUTE},
  { path: HEADER_LIST_ROUTE, component: UpdateHeader,permissions: routeConfig.HEADER_LIST_ROUTE},
  { path: DASHBOARD_LIST_ROUTE, component: DashBoard,permissions: routeConfig.DASHBOARD_LIST_ROUTE},
  { path: INDEX_UPLOAD_LIST_ROUTE, component: IndexUpload,permissions: routeConfig.INDEX_UPLOAD_LIST_ROUTE},
  { path: JOB_APPLICATION_LIST_ROUTE, component: JobApplicationList,permissions: routeConfig.JOB_APPLICATION_LIST_ROUTE},
  { path: ADDITIONAL_HTML_LIST_ROUTE, component: AdditionalHtml,permissions: routeConfig.ADDITIONAL_HTML_LIST_ROUTE},
  { path: NOTICE_LIST_ROUTE, component: NoticeList,permissions: routeConfig.NOTICE_LIST_ROUTE},
  { path: BLOG_CATEGORY_LIST_ROUTE, component: Category,permissions: routeConfig.BLOG_CATEGORY_LIST_ROUTE},
  { path: AUDIT_LOG_LIST_ROUTE, component: Auditlog,permissions: routeConfig.AUDIT_LOG_LIST_ROUTE},
];

const publicRoutes = [
  // authentication
  
  { path: LOGIN_LIST_ROUTE, component: Login,permissions: routeConfig.LOGIN_LIST_ROUTE },
  { path: FORGET_PASSWORD_LIST_ROUTE, component: ForgetPassword ,permissions: routeConfig.FORGET_PASSWORD_LIST_ROUTE},
  { path: RESET_PASSWORD_LIST_ROUTE, component: ResetPassword,permissions: routeConfig.RESET_PASSWORD_LIST_ROUTE },
  { path: LOGOUT_LIST_ROUTE, component: Logout,permissions: routeConfig.LOGOUT_LIST_ROUTE },
];

export { authProtectedRoutes, publicRoutes };
